// extracted by mini-css-extract-plugin
export default {"orgModal":"ChooseOrg_orgModal__XTO6n","scrollDiv":"ChooseOrg_scrollDiv__2OY0i","orgModalHeader":"ChooseOrg_orgModalHeader__Oji51","orgModalTitle":"ChooseOrg_orgModalTitle__w2UAa"};